import React, { PureComponent, useRef } from "react";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import { getToken, getCurrentUser } from "utils/storage";
import { getStatus } from "@/utils/methods";
import "./index.scss";
import ApproveModal from "@/components/ApproveModal";

import server1 from "../../images/home/server1.png";
import server2 from "../../images/home/server2.png";
import server3 from "../../images/home/server3.png";
import studyEdu from "../../images/home/studyEdu.png";
import detailBtn from "../../images/home/detailBtn.png";
import { Link } from "react-router-dom";

import {
  Input,
  Button,
  Tabs,
  Pagination,
  Modal,
  Row,
  Col,
  Empty,
  message,
} from "antd";

const { TabPane } = Tabs;

const { Search } = Input;

//线下课程培训详情页面路由   /entrance/eduDetail
//线上课程详情页面路由       /entrance/eduInlineDetail
export default class EducationTraining extends PureComponent {
  state = {
    isModalVisible: false,
    TraList: [],
    courseList: [],
    courseInfo: {},
    loading: false,
    selectId: "",
    current: 1,
    isNotTest: false,
    selectIdTwo: "",
    selectIdThree: 5,
    major: "",
    trainingType: "",
    classList: [],
  };

  componentDidMount() {
    this.getListData();
    this.getTrainList();
    this.modalRef = React.createRef();
    this.getClassList();
  }
  getClassList = () => {
    Http.get(
      Request.getEduList(),
      { current: 1, size: 4, trainingType: "0" },
      (obj) => {
        if (obj.code == 200) {
          console.log("objobjobjobj", obj, obj.data.records);
          this.setState({ classList: obj.data.records });
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  };
  judgeLogin = (statu) => {
    this.props.history.push({
      pathname: "/entrance/promiseBook",
    });
    // const userInfo = getCurrentUser();
    // if (userInfo) {
    //   if (userInfo.user_type != 2) {
    //     message.error("非退役军人不可申请");
    //     return;
    //   }
    //   this.props.history.push({
    //     pathname: "/entrance/promiseBook",
    //   });
    //   // if (statu == 0) {
    //   //   this.props.history.push({
    //   //     pathname: "/entrance/promiseBook",
    //   //     state: 0,
    //   //   });
    //   // } else if (statu == 1) {
    //   //   this.props.history.push({
    //   //     pathname: "/entrance/promiseBook",
    //   //     state: 1,
    //   //   });
    //   // }
    // } else {
    //   message.info("请先登录");
    //   this.props.history.push("/login");
    // }
  };
  goDetail2 = (type, id) => {
    this.props.history.push(`/entrance/eduDetail/${id}`);
  };
  renderClassList = () => {
    const { classList } = this.state;
    console.log("classList", classList);

    return classList && classList.length
      ? classList.map((item, index) => {
          return (
            <div
              className="teachInfo"
              key={index}
              onClick={() => {
                this.goDetail2(item.trainingType, item.id);
              }}
            >
              <img src={item.courseUrl} alt="" />
              <div>
                <div className="teachName">{item.courseName}</div>
                <span className="skillInfo">{item.trainingName}</span>
              </div>
            </div>
          );
        })
      : "";
  };
  //获取列表数据
  getListData = (data) => {
    const { trainingType, major } = this.state;
    console.log("trainingType,majortrainingType,major", trainingType, major);

    let params = {
      size: 12,
      current: this.state.current,
      trainingType,
      major,
      // descs:'update_time',
      // major:1
      ...data,
    };
    Http.get(Request.getEduList(), { ...params }, (obj) => {
      if (obj.code == 200) {
        this.setState({
          courseInfo: obj.data,
          courseList: obj.data.records,
        });
      }
    });
  };
  handlePage = (page, pageSize) => {
    this.setState({ current: page }, () => {
      this.getListData(page);
    });
  };
  //获取分类列表
  getTrainList = () => {
    Http.get(Request.getTraList(), {}, (obj) => {
      if (obj.code == 200) {
        this.setState({ TraList: obj.data });
      }
    });
  };
  //行业筛选
  screenInfo = (info) => {
    this.setState({ selectIdTwo: info, major: info }, () => {
      this.getListData();
    });
  };
  //上课模式
  patternInfo = (info) => {
    this.setState({ selectIdThree: info, trainingType: info }, () => {
      this.getListData();
    });
  };
  //报名线下
  applyInfo = (data) => {
    this.setState({ loading: true });
    Http.getApplication(Request.getApply(), { id: data }, (obj) => {
      if (obj.code == 200) {
        // this.setState({TraList:obj.data})
        message.success(obj.msg);
      } else {
        message.error(obj.msg);
      }
      this.setState({ isModalVisible: false });
    });
  };

  showModal = (data, e) => {
    message.config({
      top: 50,
      duration: 1,
      maxCount: 1,
    });
    // e ? e.stopPropagation() : ''
    if (e) {
      e.stopPropagation();
    }
    if (!getCurrentUser()) {
      message.error("还未登录，请先登录后报名！");
      return;
    }
    console.log("typetypetype", getCurrentUser().user_type);
    if (getCurrentUser().user_type !== "2") {
      message.warn("非退役军人不可报名", [1]);
    } else {
      console.log("adasdasdasda", this.modalRef);
      getStatus().then((res) => {
        if (res === false) {
          this.modalRef.current.showModal();
          return;
        }

        switch (data.examination) {
          case 0:
            this.setState({ isNotTest: true });
            break;
          case 1:
            this.setState({ isNotTest: false });
            break;
        }

        this.setState({ isModalVisible: true, selectId: data.id });
        // this.applyInfo(data)
      });
    }
  };

  handleOk = () => {
    const { selectId } = this.state;
    this.applyInfo(selectId);
    // this.setState({isModalVisible:false})
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };
  onSearch = (value) => {
    console.log(value);
    if (value == "") {
      message.error("输入不能为空");
      return;
    }
    this.getListData({ courseName: value });
  };
  goDetail = (e, id) => {
    e.stopPropagation();
    console.log(e, id);
    this.props.history.push(`/entrance/eduDetail/${id}`);
  };
  goInLineDetail = (id, e) => {
    e.stopPropagation();
    // console.log(e,id);
    this.props.history.push(`/entrance/eduInlineDetail/${id}`);
  };
  getNextPage = (data) => {
    const { current } = this.state;
    if (data == "add") {
      this.getListData({ current: 1 + current });
      this.setState({ current: current + 1 });
    } else {
      this.getListData({ current: current - 1 });
      this.setState({ current: current - 1 });
    }
  };
  render() {
    const {
      isNotTest,
      TraList,
      courseList,
      courseInfo,
      loading,
      current,
      selectIdTwo,
      selectIdThree,
    } = this.state;
    const itemRender = (_, type, originalElement) => {
      if (type === "prev") {
        return <a>上一页</a>;
      }

      if (type === "next") {
        return <a>下一页</a>;
      }

      return originalElement;
    };
    return (
      <div>
        <div className="eduBox">
          <div className="newBox">
            <div style={{ boxSizing: "border-box", paddingTop: 16 }}>
              当前位置：<a>教育培训</a>
            </div>

            <div className="eduTabList" style={{ marginTop: 15, minHeight: 400 }}>
              <div className="oneSkillInfo">
                <img src={server1} alt="" />
                <div>
                  <span className="orgName">教育培训政策</span>
                  <Button
                    type="primary"
                    ghost
                    className="skillBtn"
                    onClick={() =>
                      this.props.history.push({
                        pathname: "/entrance/educationPoliciesDetails",
                        state: { id: "msjycy_jypxzc23" },
                      })
                    }
                  >
                    查看详情
                  </Button>
                </div>
              </div>
              <div className="oneSkillInfo">
                <img src={server2} alt="" />
                <div>
                  <span className="orgName">技能培训</span>
                  <Button
                    type="primary"
                    ghost
                    className="skillBtn"
                    onClick={() => this.judgeLogin()}
                  >
                    查看详情
                  </Button>
                </div>
              </div>
              <div className="oneSkillInfo">
                <img src={server3} alt="" />
                <div>
                  <span className="orgName">线上课堂</span>
                  <Button
                    type="primary"
                    onClick={() =>message.warn('敬请期待！')}
                    // onClick={() =>
                    //   this.props.history.push({
                    //     pathname: "/entrance/educationTrainingAlliance",
                    //   })
                    // }
                    ghost
                    className="skillBtn"
                  >
                    查看
                  </Button>
                </div>
              </div>
            </div>

            {/* <Tabs defaultActiveKey="1">
            <TabPane tab="技能培训" key="1">
              <div className="skillList">
                <div className="oneSkillInfo">
                  <img
                    src={server1}
                    alt=""
                  />
                  <div>
                    <span className="orgName">培训机构简介</span>
                      <Button type="primary" ghost className="skillBtn" onClick={()=>this.props.history.push({pathname:'/entrance/educationTrainingAlliance'})}>
                      查看详情
                    </Button>
                  </div>
                </div>
                <div className="oneSkillInfo">
                  <img
                    src={server2}
                    alt=""
                  />
                  <div>
                    <span className="orgName" >本地技能培训申请</span>
                    <Button type="primary" ghost className="skillBtn" onClick={()=>this.judgeLogin(0)
                      }>
                      立即申请
                    </Button>
                  </div>
                </div>
                <div className="oneSkillInfo">
                  <img
                    src={server3}
                    alt=""
                  />
                  <div>
                    <span className="orgName">异地技能培训申请</span>
                    <Button type="primary" onClick={()=>this.judgeLogin(1)
                      } ghost className="skillBtn">
                    立即申请
                    </Button>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane tab="学历教育" key="2">
              <div className="studyEdu" onClick={()=>{this.props.history.push({pathname:'/entrance/PolicyDetails',state:{id:'1547178828273651713',activeKey:1}})}}>
                <img className="bgImg" src={studyEdu} alt="" />
                <p>四川省高职扩招专项工作方案</p>
                <img className="btImg" src={detailBtn} alt="" />
              </div>
            </TabPane>
            <TabPane tab="公益课堂" key="3">
              <div className="skillList2">
                {this.renderClassList()}
              </div>
            </TabPane>
          </Tabs> */}
          </div>
          <div className="conBox" style={{display:'none'}}>
            <div className="top">
              <div className="seachBox">
                <div className="leftBox"></div>
                <div className="rightBox">
                  <Search
                    placeholder="搜索关键字"
                    onSearch={this.onSearch}
                    enterButton
                  />
                </div>
              </div>
              <div className="screenBox">
                <div className="one">
                  <div className="left_title_box">
                    <span className="screenTitle">培训行业</span>
                    <span
                      className={`screen ${
                        selectIdTwo == "" ? "screen_height_light" : ""
                      }`}
                      onClick={() => {
                        this.setState({ selectIdTwo: "", major: "" }, () =>
                          this.getListData()
                        );
                      }}
                    >
                      全部
                    </span>
                  </div>
                  <div className="right_info_box">
                    {TraList
                      ? TraList.map((item, index) => {
                          return (
                            <span
                              className={`screen ${
                                selectIdTwo == item.id
                                  ? "screen_height_light"
                                  : ""
                              }`}
                              onClick={() => this.screenInfo(item.id)}
                              key={item.id}
                            >
                              {item.cateName}
                            </span>
                          );
                        })
                      : ""}
                  </div>
                </div>
                <div className="one">
                  <span className="screenTitle">上课形式</span>
                  <span
                    className={`screen ${
                      selectIdThree == 5 ? "screen_height_light" : ""
                    }`}
                    onClick={() => {
                      this.setState(
                        { selectIdThree: 5, trainingType: "" },
                        () => this.getListData()
                      );
                    }}
                  >
                    全部
                  </span>
                  <span
                    className={`screen ${
                      selectIdThree == 0 ? "screen_height_light" : ""
                    }`}
                    onClick={() => this.patternInfo(0)}
                  >
                    线上
                  </span>
                  <span
                    className={`screen ${
                      selectIdThree == 1 ? "screen_height_light" : ""
                    }`}
                    onClick={() => this.patternInfo(1)}
                  >
                    线下
                  </span>
                </div>
              </div>
            </div>
            <div className="newsBox">
              <Row gutter={24} width={1200} style={{ width: "1200px" }}>
                {courseList && courseList.length ? (
                  courseList.map((item, index) => {
                    return (
                      <Col span={6}>
                        <div
                          className="courseInfo"
                          key={item.index}
                          onClick={() =>
                            item.trainingType == 1
                              ? this.props.history.push(
                                  `/entrance/eduDetail/${item.id}`
                                )
                              : this.props.history.push(
                                  `/entrance/eduInlineDetail/${item.id}`
                                )
                          }
                        >
                          {/* onClick={()=>this.props.history.push(`/entrance/eduDetail/${item.id}`)} */}
                          <div className="imgBox11">
                            <img src={item.courseUrl} alt="" />
                          </div>
                          <div className="Infobox">
                            <span
                              title={item.courseName}
                              className="courseName"
                            >
                              {item.courseName}
                            </span>
                            <p>{item.trainingName}</p>
                            <div
                              style={{
                                backgroundColor: "#f6f6f6",
                                height: 1,
                                margin: "10px 0 16px 0",
                              }}
                            />

                            {item.trainingType == 1 ? (
                              <div className="btnBox">
                                <Button
                                  className="skillBtn"
                                  onClick={(e) => this.goDetail(e, item.id)}
                                >
                                  查看详情
                                </Button>
                                <Button
                                  type="primary"
                                  className="skillBtn"
                                  onClick={(e) => this.showModal(item, e)}
                                >
                                  报名学习
                                </Button>
                              </div>
                            ) : (
                              <div className="btnBox">
                                <Button
                                  className="skillBtn"
                                  onClick={(e) =>
                                    this.goInLineDetail(item.id, e)
                                  }
                                >
                                  查看详情
                                </Button>
                                <Button
                                  type="primary"
                                  onClick={(e) =>
                                    this.goInLineDetail(item.id, e)
                                  }
                                >
                                  观看视频
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    );
                  })
                ) : (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                )}
              </Row>
            </div>
            <div className="footerBox ">
              <span className="inlineBox">
                <Pagination
                  total={courseInfo.total}
                  showQuickJumper
                  showTotal={(total) => `共 ${total} 条`}
                  itemRender={itemRender}
                  onChange={this.handlePage}
                  current={current}
                  defaultPageSize={12}
                  showSizeChanger={false}
                  defaultCurrent={1}
                  // showQuickJumper= {<Button className={"pagination_jump"}>确定</Button>}
                />
                <Button style={{ marginLeft: "10px" }}>确定</Button>
              </span>
            </div>
          </div>

          <Modal
            title="提示！"
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            visible={this.state.isModalVisible}
          >
            <p>
              {isNotTest == true
                ? `该课程需要参加结业考试，确定报名学习该课程？`
                : `该课程不需要参加结业考试，确定报名学习该课程？`}
            </p>
          </Modal>
          <ApproveModal ref={this.modalRef} />
        </div>
      </div>
    );
  }
}
